import { createContext, useContext, useState, useEffect } from "react";

const LandingThemeContext = createContext(null);

export function LandingThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("newsky-landing-theme") || "dark");

  useEffect(() => {
    localStorage.setItem("newsky-landing-theme", theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <LandingThemeContext.Provider value={{ theme, toggle }}>
      {children}
    </LandingThemeContext.Provider>
  );
}

export function useLandingTheme() {
  return useContext(LandingThemeContext);
}
